/* eslint-disable */

import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import * as firebase from "firebase/app";
import "firebase/auth";
import 'firebase/firestore';
import store from '../store/index';
import { usersCollection, pickersCollection, masterCollection } from '@/services/firestore-service';


Vue.use(VueRouter);

const routes = [
  {
    path: '/signin',
    name: 'SignIn',
    component: () => import('@/views/dashboard/SignIn.vue'),
  },
  {
    path: '/recuperar-senha',
    name: 'RecoverPassword',
    component: () => import('@/views/dashboard/RecoverPassword.vue'),
  },
  {
    path: '/dashboard',
    component: () => import('@/views/dashboard/DashboardView.vue'),
    children: [
      {
        path: '',
        meta: {
          requiresAuth: true,
          levels: ['picker', 'supermarket', 'admin']
        },
        component: () => import('@/views/dashboard/HomeDashboard.vue')
      },

      {
        path: 'usuarios/novo-picker',
        meta: {
          requiresAuth: true,
          levels: ['supermarket', 'admin']
        },
        component: () => import('@/views/dashboard/pickers/CreatePicker.vue')
      },

      {
        path: 'usuarios/editar-picker',
        meta: {
          requiresAuth: true,
          levels: ['supermarket', 'admin']
        },
        component: () => import('@/views/dashboard/pickers/ListPickers.vue')
      },


      {
        path: 'profile',
        name: 'Profile',
        meta: {
          requiresAuth: true,
        },
        component: () => import('@/views/dashboard/settings/Profile.vue')
      },

      {
        path: 'configuracoes-avancadas',
        meta: {
          requiresAuth: true,
          levels: ['supermarket', 'admin']
        },
        component: () => import('@/views/dashboard/settings/AdvancedSettings.vue')
      },

      {
        path: 'picking',
        meta: {
          requiresAuth: true,
        },
        component: () => import('@/views/dashboard/pickers/Picking.vue')
      },

      {
        path: 'usuarios/novo-usuario',
        meta: {
          requiresAuth: true,
          levels: ['admin']
        },
        component: () => import('@/views/dashboard/users/CreateAdminUser.vue'),
      },

      {
        path: 'usuarios/editar-usuario',
        meta: {
          requiresAuth: true,
          levels: ['admin']
        },
        component: () => import('@/views/dashboard/users/ListAdminUsers.vue'),
      },
      {
        path: 'relatorios/vendas',
        meta: {
          requiresAuth: true,
          levels: ['admin', 'supermarket']
        },
        component: () => import('@/views/dashboard/reports/SellsReport.vue')
      },
      {
        path: 'relatorios/produtos-vendidos',
        meta: {
          requiresAuth: true,
          levels: ['admin', 'supermarket']
        },
        component: () => import('@/views/dashboard/reports/SoldProductsReport.vue')
      },
      {
        path: 'relatorios/supermercados',
        meta: {
          requiresAuth: true,
          levels: ['admin', 'supermarket']
        },
        component: () => import('@/views/dashboard/reports/SupermarketsReport.vue')
      },
      {
        path: 'relatorios/clientes',
        meta: {
          requiresAuth: true,
          levels: ['admin', 'supermarket']
        },
        component: () => import('@/views/dashboard/reports/CustomersReport.vue')
      },
      {
        path: 'supermercados/listagem',
        meta: {
          requiresAuth: true,
          levels: ['admin']
        },
        component: () => import('@/views/dashboard/supermarkets/ListSupermarkets.vue')
      },

      {
        path: 'planos/editar-plano',
        meta: {
          requiresAuth: true,
          levels: ['admin']
        },
        component: () => import('@/views/dashboard/plans/ListPlans.vue')
      },

      {
        path: '*',
        name: 'NotFoundAdmin',
        component: () => import('@/views/admin/NotFound.vue')
      }
    ]
  },
  {
    path: '',
    component: () => import('@/views/FrontView.vue'),
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home
      },
      {
        path: '/como-funciona',
        name: 'ComoFunciona',
        component: () => import('@/views/ComoFunciona.vue')
      },

      {
        path: '/termos',
        name: 'Terms',
        component: () => import('@/views/Terms.vue')
      },


      {
        path: '/politica-de-privacidade',
        name: 'PrivacyPolicy',
        component: () => import('@/views/PrivacyPolicy.vue')
      },

      {
        path: '/contato',
        name: 'Contato',
        component: () => import('@/views/Contato.vue')
      },

      {
        path: '/about',
        name: 'About',
        component: () => import('../views/About.vue')
      },

      {
        path: '/criar-conta',
        component: () => import('../views/front/signup/SignUp.vue'),
        children: [
          { path: 'user', name: 'SignUpRegister', component: () => import('../views/front/signup/SignUpRegister.vue') },
          { path: 'plans', name: 'SignUpPlans', component: () => import('../views/front/signup/SignUpChoosePlans.vue') },
          { path: 'payment', name: 'SignUpPayment', component: () => import('../views/front/signup/SignUpPayment.vue') },
        ]
      },

      {
        path: '/assinar-plano',
        name: 'AssinarPlano',
        component: () => import('@/views/AssinarPlano.vue')
      },

      {
        path: '*',
        name: 'NotFound',
        component: () => import('@/views/NotFound.vue')
      }
    ]
  },


]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'is-active',
  routes
});

router.afterEach((to, from) => {
  if (from.name && from.name !== 'SignIn' && to.name === 'SignIn') location.reload();
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const levels = to.matched
    .filter(record => record.meta.requiresAuth)
    .map(record => record.meta.levels)
    .filter(levels => levels && levels.length)[0];

  const currentUser = await firebase.getCurrentUser();
  if (requiresAuth && !currentUser) next('/signin');

  if (requiresAuth) {
    const { claims, token } = (await currentUser.getIdTokenResult()) || {};
    if (store.state.authUser != currentUser) store.state.authUser = currentUser;
    store.state.authUser.claims = claims;
    store.state.authUser.token = token;

    const collection = claims && claims.role === 'admin' ? masterCollection : (claims && claims.role === 'picker' ? pickersCollection : usersCollection);

    if (!store.state.userData || Object.keys(store.state.userData).length === 0) {
      const docSnapshot = await collection.doc(currentUser.uid).get();
      const userData = docSnapshot.data();

      store.state.userData = userData;
      store.state.userData.id = docSnapshot.id;
      store.state.userData.type = claims.role;
      store.state.userData.reference = docSnapshot.ref;

      if (userData.hasConfig) {
        const configs = await collection.doc(currentUser.uid).collection('configs').doc('api').get();
        if (configs.exists) store.state.userData.configs = configs.data();
      }
    }
    
    if (levels && claims && !levels.includes(claims.role)) {
      if (claims.type !== 'picker') return next('/dashboard/error');
      else return next('/dashboard/picking');
    }

  }

  return next();
});


export default router
